import React, { useState } from 'react';
import SimpleTable from 'components/common/SimpleTable';
import ButtonDelete from 'utils/buttons/ButtonDelete';
import ButtonEdit from 'utils/buttons/ButtonEdit';
import ButtonView from 'utils/buttons/ButtonView';
import { checkPermission } from 'utils/checkPermission';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { deleteRol, getRolByRealEstate } from 'redux/rolesSlice';
import ConfirmarBorrado from './modals/ConfirmarBorrado';
import ViewRol from './modals/ViewRol';

const Actions = ({
  data: {
    row: {
      original: { name, id, roleToPermission }
    }
  },
  userLogged,
  openModalDelete,
  openModalView,
  setOpenEditModal
}) => {
  return (
    <div className="d-flex justify-content-start gap-3">
      <ButtonView
        funcion={openModalView}
        data={{ name: name, id: id, permisos: roleToPermission }}
        iconEye
        disabled={!checkPermission('Edit roles', userLogged)}
      />

      <ButtonEdit
        data={id}
        funcion={setOpenEditModal}
        disabled={!checkPermission('Edit roles', userLogged)}
      />

      <ButtonDelete
        funcion={openModalDelete}
        data={{
          name: name,
          id: id,
          permisos: roleToPermission
        }}
        disabled={!checkPermission('Delete roles', userLogged)}
      />
    </div>
  );
};

Actions.propTypes = {
  data: PropTypes.object.isRequired,
  userLogged: PropTypes.object.isRequired,
  openModalDelete: PropTypes.func.isRequired,
  openModalView: PropTypes.func.isRequired,
  setOpenEditModal: PropTypes.func.isRequired
};

const initialRole = {
  id: '',
  name: '',
  roleToPermission: []
};

const ListaRoles = ({
  listaRoles,
  userLogged,
  setOpenEditModal,
  realEstate
}) => {
  const dispatch = useDispatch();

  //Modal borrar rol
  const [openDelete, setOpenDelete] = useState(false);
  //Modal ver rol
  const [openView, setOpenView] = useState(false);

  const [usedRole, setUsedRole] = useState(initialRole);

  const columns = [
    {
      accessor: 'name',
      Header: 'Nombre'
    },
    {
      accessor: 'roleToUser.length',
      Header: 'Usuarios con este rol'
    },
    {
      accessor: 'id',
      Header: 'Acciones',
      disableSortBy: true,
      Cell: data => (
        <Actions
          data={data}
          openModalDelete={openModalDelete}
          openModalView={openModalView}
          userLogged={userLogged}
          setOpenEditModal={setOpenEditModal}
        />
      )
    }
  ];

  //Handlers
  const openModalDelete = data => {
    setOpenDelete(true);
    setUsedRole({
      name: data.name,
      id: data.id,
      roleToPermission: data.permisos
    });
  };

  const openModalView = data => {
    setOpenView(true);
    setUsedRole({
      name: data.name,
      id: data.id,
      roleToPermission: data.permisos
    });
  };

  const closeModalDelete = () => {
    setOpenDelete(false);
    setUsedRole(initialRole);
  };

  const closeModalView = () => {
    setOpenView(false);
    setUsedRole(initialRole);
  };

  const handleDelete = async id => {
    await dispatch(deleteRol(id));
    await dispatch(getRolByRealEstate(realEstate.id));
    setOpenDelete(false);
  };

  return (
    <>
      <SimpleTable
        columns={columns}
        data={listaRoles}
        emptyMessage={{ title: 'No hay roles creados', message: ' ' }}
      />

      {openDelete && (
        <ConfirmarBorrado
          closeModalDelete={closeModalDelete}
          handleDelete={handleDelete}
          rol={usedRole}
        />
      )}
      {openView && <ViewRol closeModalView={closeModalView} rol={usedRole} />}
    </>
  );
};

ListaRoles.propTypes = {
  listaRoles: PropTypes.array.isRequired,
  userLogged: PropTypes.object.isRequired,
  setOpenEditModal: PropTypes.func.isRequired,
  realEstate: PropTypes.object.isRequired
};

export default ListaRoles;
